/*
 * @Author: zenghao
 * @Date: 2022-04-12 16:08:44
 * @LastEditors: zenghao
 * @LastEditTime: 2022-04-21 11:55:13
 * @Description: 请填写简介
 */
import { ChartType } from './types'

export const CHART_TYPE: {
	[key: string]: ChartType
} = {
  BAR: 'bar',
	LINE: 'line',
	PIE: 'pie',
	TABLE: 'table'
}

export const EXCEL_COLUMN = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
